import templateUrl from "emun.order/order-details-shop.htm";

export default () => ({ templateUrl });
